import ApiResponse from '../../api/response.js'

const state = {
  data: null,
  loading: false,
  error: null
}

const mutations = {
  fetch (state) {
    state.loading = true
    state.error = null
  },

  success (state, data) {
    state.loading = false
    state.data = data
  },

  failure (state, err) {
    state.loading = false
    state.error = err
  }
}

const actions = {
  fetch ({commit}, {id}) {
    commit('fetch')

    ApiResponse.fetchTestQuestions(id)
      .then(response => {
        if (!response.data || !response.data[0]) {
          throw new Error('Invalid response format')
        }
        commit('success', response.data[0])
      })
      .catch(err => commit('failure', err))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
